import { css } from 'emotion'
import { Colors, Easings, Link } from './..'

export const NotificationStyle = (open) => css({
  position: 'fixed',
  top: 60,
  left: 0,
  zIndex: 4,
  width: '100%',
  height: 'calc(100% - 60px)',
  lineHeight: 1.2,
  overflow: 'auto',
  padding: '1rem',
  transform: `scaleY(${open ? 1 : 0})`,
  visibility: open ? 'visible' : 'hidden',
  transformOrigin: 'top center',
  boxShadow: `0 5px 20px 0 ${Colors.shadow}`,
  background: 'white',
  transition: `transform 300ms ${Easings.customEase} ${ open ? 0 : 300}ms, visibility 0ms ease ${ open ? 0 : 600}ms`,
  cursor: 'default',
  textAlign: 'left',
  '@media (min-width: 1024px)': {
    position: 'absolute',
    width: 260,
    maxHeight: 220,
    height: 'auto',
    top: 'auto',
    left: 'auto',
    bottom: 0,
    right: 0,
    transform: `translateY(100%) scaleY(${open ? 1 : 0})`,
  },
  '.notification-line': {
    margin: '1rem 0px', 
    textTransform: 'uppercase',
    opacity: open ? 1 : 0,
    transition: `opacity 300ms ease ${open ? 300 : 0}ms`,
    '&:first-child': {
      marginTop: 0
    },
    '&:last-child': {
      marginBottom: 0
    },
    'a': {
      display: 'flex',
      alignItems: 'center',
    },
    '.icon': {
      flexBasis: '16px',
      width : '16px',
      marginRight: '1rem',
      position: 'relative',
      'svg': {
        fill: 'black',
        transition: 'fill 400ms ease',
      }
    },
    '.label': {
      ...Link,
      fontWeight: 'bold',
      color: Colors.darkGrey,
      flexBasis: 'calc(100% - 16px)',
      maxWidth: 'calc(100% - 16px)',
    },
    '&.hightlight': {
      '.icon': {
        '&:after': {
          content: "''",
          position: 'absolute',
          top: 3,
          right: -1,
          width: 5,
          height: 5,
          borderRadius: 9999,
          background: Colors.red,
          border: '1px solid white',
        }
      }
    },
    '&.alert': {
      '.label': {
        color: Colors.red,
        '&:hover': {
          color: '',
        }
      },
      '.icon svg': {
        fill: Colors.red
      }
    },
  }
})




// WEBPACK FOOTER //
// ./src/styles/components/notification.js